module.exports = __webpack_public_path__ + "img/blue_104.a80b12af.png";